// src/components/Legends.jsx
import React, { useState } from 'react';
import { useTheme } from '../theme/ThemeContext';
import LegendHierarchy from './legendHierarchy';
import ContinuousLegend from './continuousLegend';
import RegularLegend from './regularLegend';
import arrowIconWhite from '../static/images/simple_arrow_icon_white.png';
import arrowIconLight from '../static/images/simple_arrow_icon_black.png';

const Legends = ({
    scatterColorCategory,
    scatterplot,
    colorDict,
    colors,
    uniqueCategories,
    colorParentSelected,
    setColorParentSelected,
    possibleColorDict,
    setPendingSelection,
    values,
    setCatigoricalResolution,
    loadingColor,
    continuousCategories,
    ids
}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { theme } = useTheme();
    const arrowIcon = theme.name === 'light' ? arrowIconLight : arrowIconWhite;

    const baseStyles = {
        fontFamily: 'Arial',
        // backgroundColor: theme.colors.overlay,
        zIndex: 1000,
        // outline: '1px solid blue',
    };

    const containerStyles = {
        position: 'fixed',
        bottom: 0,
        left: 0,
        margin: '20px',
        backgroundColor: theme.colors.overlay,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        borderRadius: '10px',
        transition: 'all 0.3s ease-in-out',
        // continuousCategories.includes(scatterColorCategory) ? 'padding' : 'width': 'auto',
        padding: continuousCategories.includes(scatterColorCategory) ? '10px 0px 0px 0px' : '40px 0px 0px 0px',
        width: isCollapsed ? 'auto' : undefined,
        height: isCollapsed ? 'auto' : undefined,
    };

    const toggleButtonStyles = {
        position: 'absolute',
        userSelect: 'none',
        // userDrag: 'none',
        // WebkitUserDrag: 'none',
        // outline: '1px solid red',
        ...(isCollapsed
            ? {
                bottom: '10px',
                left: '10px',
            }
            : {
                top: '10px',
                right: '10px',
            }
        ),
        background: 'none',
        border: 'none',
        padding: '5px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: isCollapsed ? 'none' : 'rotate(180deg)',
        transition: 'transform 0.3s ease'
    };

    const loadingStyles = {
        padding: '40px 160px 40px 160px',
        alignItems: 'center',
        color: theme.colors.text,
        fontFamily: 'Arial',
        fontSize: '24px'
    };

    const iconStyles = {
        width: '20px',
        height: '20px',
    };

    const handleRangeSelect = (minVal, maxVal, selectedCount) => {
        console.log(`Selected range: ${minVal.toFixed(2)} - ${maxVal.toFixed(2)}, ${selectedCount} samples`);
    };

    const renderLegend = () => {
        if (!isCollapsed) {
            if (loadingColor) {
                return <div style={loadingStyles}>Loading...</div>;
            }
            // if (scatterColorCategory === 'source_biome') {
            if (scatterColorCategory === 'source_biome' || scatterColorCategory === 'geographic_location') {

                return (
                    <LegendHierarchy
                        uniqueCategories={uniqueCategories}
                        colorParentSelected={colorParentSelected}
                        setColorParentSelected={setColorParentSelected}
                        colors={colors}
                        colorDict={colorDict}
                        scatterplot={scatterplot}
                        possibleColorDict={possibleColorDict}
                        setPendingSelection={setPendingSelection}
                        styles={baseStyles}
                    />
                );
            } else if (continuousCategories.includes(scatterColorCategory)) {
                return (
                    <ContinuousLegend
                        values={values}
                        scatterColorCategory={scatterColorCategory}
                        styles={baseStyles}
                        onRangeSelect={handleRangeSelect}
                        scatterplot={scatterplot}
                        ids={ids}
                    />
                );
            } else {
                return (
                    <RegularLegend
                        colorDict={colorDict}
                        scatterplot={scatterplot}
                        colors={colors}
                        scatterColorCategory={scatterColorCategory}
                        setCatigoricalResolution={setCatigoricalResolution}
                        styles={baseStyles}
                    />
                );
            }
        }
        return null;
    };

    return (
        <div style={containerStyles}>
            {renderLegend()}
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                draggable="false"
                onDragStart={(e) => e.preventDefault()}
                style={toggleButtonStyles}
            >
                <img
                    src={arrowIcon}
                    alt="toggle"
                    style={iconStyles}
                />
            </button>
        </div>
    );
};

export default Legends;